<!-- Not used -->
<template>
<span class="inline-flex bg-fuchsia-500 text-white rounded-full h-10 text-lg px-6 justify-center items-center">{{this.content}}</span>
</template>

<script>
export default {
  name: 'ButtonMore',
  props: {
    content: { type: String, default: "Więcej..." }
  }
}
</script>
